module.exports = __webpack_public_path__ + "static/img/coupon.858bf10.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/coupon.png
// module id = 9Wpc
// module chunks = 6